export default __webpack_public_path__ + "static/media/congratulation.7793d2b7.png";